export default "__VITE_ASSET__35d51bbe__"